import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../../data/content';
export function Pricing() {
  return <section id="pricing" className="py-20 relative scroll-mt-20" data-id="element-199" data-mp="3bsctwlxdecv2">
      <div className="container mx-auto px-4" data-id="element-200" data-mp="3bq045mldey7g">
        <div className="text-center mb-16" data-id="element-201" data-mp="3gj2yhwxz2bop">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-ink mb-4" data-id="element-202" data-mp="3gkw7vjzyza0e">
            ELEGÍ TU MEGA PACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch" data-id="element-203" data-mp="3piydkcunequ0">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-surface border border-line flex flex-col h-full" data-id="element-204" data-mp="3ui2q9dgs76p3">
            <div className="mb-6" data-id="element-205" data-mp="206nxsowdyt5n">
              <h3 className="text-2xl font-bold text-ink mb-2 flex items-start gap-2" data-id="element-206" data-mp="253effgnu9wt6">
                <span aria-hidden="true" data-id="element-207" data-mp="1baqdxtg3jx6k">📗</span> MEGA PACK COCINA LISTA
              </h3>
              <p className="text-pistachio-700 font-medium" data-id="element-208" data-mp="1bckxb3bpzh8j">6 Tomos + 6 Bonos</p>
            </div>

            <p className="text-muted text-sm mb-8 flex-grow" data-id="element-209" data-mp="16i73348sng5g">
              <span className="font-semibold text-ink" data-id="element-210" data-mp="11lgka95lu6gc">Ideal para:</span> Empezar el sistema
              completo de alimentación semanal
            </p>

            <div className="mb-8" data-id="element-211" data-mp="1u9cixjeqi8fr">
              <div className="text-muted/70 line-through text-lg font-medium mb-1" data-id="element-212" data-mp="1u8b5x9e5rbve">
                $52.000 ARS
              </div>
              <div className="text-5xl font-display font-bold text-ink flex items-baseline gap-2" data-id="element-213" data-mp="1p8f2bb9dhmgd">
                $19.990{' '}
                <span className="text-xl text-muted font-sans font-medium" data-id="element-214" data-mp="1ga386z9as6j6">ARS</span>
              </div>
              <p className="text-xs text-muted mt-2" data-id="element-215" data-mp="9uai7n6bpyof">pago único · acceso inmediato</p>
            </div>

            <Button size="lg" fullWidth variant="secondary" href={CHECKOUT_BASIC} data-id="element-216" data-mp="4u4u2gz9iub3">
              → QUIERO MI MEGA PACK
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="p-8 rounded-3xl bg-pistachio-100 border-2 border-pistachio-400 flex flex-col h-full relative shadow-[0_16px_40px_-24px_rgba(104,143,58,0.5)]" data-id="element-217" data-mp="6a0l5zlvoz0u">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-pistachio-400 text-pistachio-900 text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full flex items-center gap-1 shadow-sm whitespace-nowrap" data-id="element-218" data-mp="3jp5an1ac4box">
              <span aria-hidden="true" data-id="element-219" data-mp="39qpgepg0gmb7">⭐</span> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-220" data-mp="3erwpcrtw3rjg">
              <h3 className="text-2xl font-bold text-ink mb-2 flex items-start gap-2" data-id="element-221" data-mp="30s43b9tb5zht">
                <span aria-hidden="true" data-id="element-222" data-mp="35qyv31996ye2">🏆</span> MEGA PACK + SISTEMA TOTAL
              </h3>
              <p className="text-pistachio-800 font-medium" data-id="element-223" data-mp="35srqtlibvy7a">
                6 Tomos + 6 Bonos + Método Cocina Impecable
              </p>
            </div>

            <p className="text-ink/80 text-sm mb-8 flex-grow" data-id="element-224" data-mp="2h7dl4o5jlp0h">
              <span className="font-semibold text-ink" data-id="element-225" data-mp="2v5lbuebzju37">Ideal para:</span> La solución
              completa de alimentación y hogar
            </p>

            <div className="mb-8" data-id="element-226" data-mp="2r2otmoqcxzzs">
              <div className="text-muted/70 line-through text-lg font-medium mb-1" data-id="element-227" data-mp="35414wmukpdfc">
                $71.000 ARS
              </div>
              <div className="text-5xl font-display font-bold text-ink flex items-baseline gap-2" data-id="element-228" data-mp="305ptw8sjkwvj">
                $27.990{' '}
                <span className="text-xl text-muted font-sans font-medium" data-id="element-229" data-mp="3etavtzdokq1v">ARS</span>
              </div>
              <p className="text-xs text-muted mt-2" data-id="element-230" data-mp="39vj71e8c1k1w">pago único · acceso inmediato</p>
            </div>

            <Button size="lg" fullWidth href={CHECKOUT_PREMIUM} data-id="element-231" data-mp="3nusf1qmdx7us">
              → QUIERO EL SISTEMA TOTAL
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}